
import { Mixins, Component } from 'vue-property-decorator';
import { IBTNCONF } from '@/types/base.d';
import api from '@/api/course';
import tButton from '@/components/Button/tButton.vue';
import BsMixin from '@/views/Home/mixins/bsMixin';
import tableMixin from './tableMixin';
import cModal from './components/cModal.vue';
import eitorContent from './components/editContent.vue';

@Component({
  components: {
    tButton,
    cModal,
    eitorContent,
  },
})
export default class AssetWrapper extends Mixins(BsMixin, tableMixin) {
  private arrs: Array<any> = [];

  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/course/chapter/homework:add',
    icon: 'plus',
    callback: this.handleAddResource,
    log: {
      name: '试听管理 - 新增',
      component: 'trial/manage/bModal',
    },
  }];

  private visible: boolean = false;

  private row: any = {};

  private eVisible: boolean = false;

  private eFrom: any = [];

  private eTitle: any = '';

  private title: string = '添加作业';

  public $refs!: {
    list: Element,
  }

  mounted() {
    this.initBS(this.$refs.list);
  }

  handleAddResource() {
    this.row.stepId = this.chapterId;
    this.title = '添加作业';
    this.visible = true;
  }


  handleEdit(row: any) {
    this.visible = true;
    this.title = '修改作业';
    this.row = row;
  }

  refrsh() {
    this.getData(this.chapterId);
  }

  handleContent(row: any) {
    this.eVisible = true;
    this.eTitle = '添加/修改内容';
    this.eFrom = row;
  }
}
